import { createSelector } from 'reselect';
import { mapValues } from 'lodash';
import {
  makeSelectAccountPerks,
  makeSelectUserType,
  makeSelectIsUserGuest,
  makeSelectIsProdegeUser,
} from 'containers/User/selectors';

import {
  makeSelectSurveyType,
  makeSelectSurveyStatusName,
  makeSelectSurveyConfig,
} from 'containers/Survey/selectors';

import {
  makeSelectIsScheduled,
  makeSelectIsRecurring,
} from 'components/SchedulingForm/selectors';
import {
  makeSelectAnswersWithLogicFromOutcomesHide,
  makeSelectFormattedNodes,
  makeSelectIsQuestionnaireInRevisionPreviewMode,
  makeSelectIsFinalisedUnderEdit,
  makeSelectRandomizeQuestionnaireEnabled,
  makeSelectHiddenNodes,
} from 'containers/QuestionnairePage/selectors';
import { makeSelectAiIsIdle } from 'containers/AISurveyBuilder/selectors';
import { makeSelectHiddenVariables } from 'modules/HiddenVariables/selectors';

import {
  SURVEY_EDIT_PERMISSIONS,
  SURVEY_NAVIGATION_PERMISSIONS,
  SURVEY_VISIBILITY_PERMISSIONS,
} from './ruleset';

/**
 * Default selector used by AccountCard
 */

const makeSelectPermissions = (itemToCheck = {}) =>
  createSelector(
    makeSelectAccountPerks,
    makeSelectUserType,
    makeSelectSurveyType,
    makeSelectSurveyStatusName,
    makeSelectIsUserGuest,
    makeSelectIsProdegeUser,
    makeSelectIsScheduled,
    makeSelectIsRecurring,
    makeSelectSurveyConfig,
    makeSelectIsQuestionnaireInRevisionPreviewMode,
    makeSelectAiIsIdle,
    makeSelectHiddenVariables,
    makeSelectFormattedNodes,
    makeSelectAnswersWithLogicFromOutcomesHide,
    makeSelectIsFinalisedUnderEdit,
    makeSelectRandomizeQuestionnaireEnabled,
    makeSelectHiddenNodes,
    (
      perks,
      userType,
      surveyType,
      surveyStatus,
      isGuest,
      isProdege,
      surveyIsScheduled,
      surveyIsRecurring,
      surveyConfig,
      isInRevisionPreviewMode,
      isAiIdle,
      hiddenVariables,
      nodes,
      answersWithLogicFromOutcomesHide,
      isFinalisedUnderEdit,
      isRandomizedQuestionnaire,
      hiddenNodes,
    ) => {
      const allPermissions = {
        ...SURVEY_EDIT_PERMISSIONS,
        ...SURVEY_NAVIGATION_PERMISSIONS,
        ...SURVEY_VISIBILITY_PERMISSIONS,
      };
      const surveyFeatures = {
        surveyIsScheduled,
        surveyIsRecurring,
      };

      return mapValues(allPermissions, (calculatePermission) =>
        calculatePermission({
          userType,
          perks,
          surveyType,
          surveyStatus,
          isGuest,
          isProdege,
          surveyFeatures,
          surveyConfig,
          isInRevisionPreviewMode,
          isAiIdle,
          hiddenVariables,
          nodes,
          answersWithLogicFromOutcomesHide,
          isFinalisedUnderEdit,
          isRandomizedQuestionnaire,
          itemToCheck,
          hiddenNodes,
        }),
      );
    },
  );

export default makeSelectPermissions;
